module.exports = __webpack_public_path__ + "img/2.60b0f9a5.jpg";